import { render, staticRenderFns } from "./ThePriceCompetitorHistoryPrices.vue?vue&type=template&id=099886e5&scoped=true&"
import script from "./ThePriceCompetitorHistoryPrices.vue?vue&type=script&lang=js&"
export * from "./ThePriceCompetitorHistoryPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099886e5",
  null
  
)

export default component.exports